export default {
  masterUpdateIndex: 0,
  allMaterials: [],
  realizations: [],
};
